
import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ImageInterface } from '@/utils/image'

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class AppImagePreview extends Vue {
    @Prop() public image!: [number, ImageInterface]

    get imageUrl(): string {
        return this.image[1].imageURL
    }

    @Emit('onRemovePreview')
    public removePreview(event: Event) {
        event.stopPropagation()

        return this.image
    }
}
